import Api from '@/api/api.js'

export default {
    //Consultation
    putConstante(id, data) {
        const promise = Api().put('consultations/prendre_constante/' + id, data)
        return promise.then((response) => response.data)
    },

    saveConsultation(data) {
        const promise = Api().post('consultations/create', data)
        return promise.then((response) => response.data)
    },

    saveOrgane(data) {
        const promise = Api().post('organe', data)
        return promise.then((response) => response.data)
    },

    sendTodocteur(id, data) {
        const promise = Api().put('consultations/send_to_doctor/' + id, data)
        return promise.then((response) => response.data)
    },

    /**
     * 
     * @param {*} id 
     * @param {*} data 
     * @deprecated - Remove
     * @returns 
     */
    selectAnalyse(id, data) {
        const promise = Api().post('/consultations/' + id + '/select-analyses', data)
        return promise.then((response) => response.data)
    },

    getDemandeAnalyses(id) {
        const promise = Api().get('/consultations/' + id + '/analyses_demandes')
        return promise.then((response) => response.data)
    },

    deleteDemandeAnalyse(data) {
        const promise = Api().post('/analyses/delete/demande', data)
        return promise.then((response) => response.data)
    },

    getMomentsConsultations() {
        const promise = Api().get('/moments_consultations')
        return promise.then((response) => response.data)
    },

    getListeTypeConsultations() {
        const promise = Api().get('/types_consultations')
        return promise.then((response) => response.data)
    },

    saveTypeConsultation(data) {
        const promise = Api().post('/config/type_consultation/store', data)
        return promise.then((response) => response.data)
    },

    deleteTypeConsultation(data) {
        const promise = Api().post('/config/type_consultation/delete', data)
        return promise.then((response) => response.data)
    },

    saveTarifsConsultations(data) {
        const promise = Api().post('/tarifs-consultations', data)
        return promise.then((response) => response.data)
    },

    getTarifsConsultations() {
        const promise = Api().get('/tarifs-consultations')
        return promise.then((response) => response.data)
    },


    getConsultationAttente(data) {
        if (data.type_consultation && data.type_consultation == 'CPN') {
            const promise = Api().get('/consultations/attente/'+data.auth_id+'/' + data.type_consultation)
            return promise.then((response) => response.data)
        } else {
            const promise = Api().get('/consultations/attente/'+data.auth_id)
            return promise.then((response) => response.data)
        }
    },

    getCountTodayConsultations(type_cons) {
        if (type_cons) {
            const promise = Api().get('/consultations/count_today/' + type_cons)
            return promise.then((response) => response.data)
        } else {
            const promise = Api().get('/consultations/count_today')
            return promise.then((response) => response.data)
        }
    },

    getCountMonthConsultations(month, type_cons) {
        if (!type_cons) type_cons = '' //si le type de consultation n'a pas été renseigné
        const promise = Api().get('/consultations/count_month?month=' + month + '&type_cons_abr=' + type_cons)
        return promise.then((response) => response.data)
    },

    getPatientConsultations(id, cpn_param) {
        if (cpn_param) {
            const promise = Api().get('/consultations/patients/' + id + '/' + cpn_param)
            return promise.then((response) => response.data)
        } else {
            const promise = Api().get('/consultations/patients/' + id)
            return promise.then((response) => response.data)
        }
    },

    /**
     * Récupére uniquement l'ID de la consultation en cours d'un patient
     * @param {*} id 
     * @returns 
     */
    getPatientConsultationId(patient_id) {
        const promise = Api().get('/consultations/' + patient_id + '/encours')
        return promise.then((response) => response.data)
    },

    getPatientLatestConsultation(data) {
        const promise = Api().post('/consultations/consultation-encours/patients', data)
        return promise.then((response) => response.data)
    },

    getEtatsPatient() {
        const promise = Api().get('/etats_patients')
        return promise.then((response) => response.data)

    },

    getOrganesAExaminer() {
        const promise = Api().get('/organes')
        return promise.then((response) => response.data)
    },

    getOrganesAExaminerNotSelected(consultationId) {
        const promise = Api().get('/organes/not-selected/' + consultationId)
        return promise.then((response) => response.data)

    },

    attachOrganesAExaminer(id, data) {
        const promise = Api().put('/consultations/' + id + '/attach-organes', data)
        return promise.then((response) => response.data)
    },

    saveConsultationOrdonnance(data) {
        const promise = Api().post('/ordonnances/save', data)
        return promise.then((response) => response.data)
    },
    saveExamenClinique(data) {
        const promise = Api().put('/consultations/examens-cliniques/save', data)
        return promise.then((response) => response.data)

    },
    saveMotifHistoire(consultationId, data) {
        const promise = Api().put('/consultations/' + consultationId + '/motif-histoire/save', data)
        return promise.then((response) => response.data)

    },
    saveHypothesesDiagnostiques(consultationId, data) {
        const promise = Api().put('/consultations/' + consultationId + '/diagnostic/save', data)
        return promise.then((response) => response.data)
    },
    savePlaintes(id,data){
        const promise = Api().put('/consultations/' + id + '/update-plaintes', data)
        return promise.then((response) => response.data)
    },

    getConsultationOrdonnance(data) {
        const promise = Api().post('ordonnances/liste-prescription', data)
        return promise.then((response) => response.data)
    },

    removePrescription(data) {
        const promise = Api().put('/consultations/prescriptions/delete', data)
        return promise.then((response) => response.data)
    },

    deleteOrdonnance(data) {
        const promise = Api().put('/ordonnances/delete', data)
        return promise.then((response) => response.data)
    },

    updatePrescription(data) {
        const promise = Api().put('/prescriptions/update', data)
        return promise.then((response) => response.data)
    },

    getListeDiagnostics() {
        const promise = Api().get('/consultations/diagnostics')
        return promise.then((response) => response.data)
    },

    saveConsultationDiagnostic(data) {
        const promise = Api().post('/consultations/diagnostics', data)
        return promise.then((response) => response.data)
    },

    removeDignostic(data) {
        const promise = Api().put('/consultations/diagnostics/remove', data)
        return promise.then((response) => response.data)
    },

    deleteDiagnosisGroup(data) {
        const promise = Api().put('/consultations/diagnosis-group/remove', data)
        return promise.then((response) => response.data)
    },

    getConsultationDiagnostics(data) {
        const promise = Api().post('/consultations/list/diagnosis', data)
        return promise.then((response) => response.data)
    },

    endConsultation(data) {
        let url = ''
        if (data.date_rdv_to_send != '') {
            url = '/consultations/' + data.consultation_id + '/cloture_consultation/' + data.date_rdv_to_send
        } else {
            url = '/consultations/' + data.consultation_id + '/cloture_consultation'
        }
        const promise = Api().get(url)

        return promise.then((response) => response.data)
    },

    getSuitesSoins(data) {

        if (data.type_consultation && data.type_consultation == 'CPN') {
            const promise = Api().get('/consultations/suites-de-soins/user_id/'+data.auth_id+'/type_consultation/'+data.type_consultation)
            return promise.then((response) => response.data)
        } else {
            const promise = Api().get('/consultations/suites-de-soins/user_id/'+data.auth_id)
            return promise.then((response) => response.data)
        }

    },
    saveProtocoleSoins(id, data) {
        const promise = Api().post('/consultations/' + id + '/protocoles-de-soins', data)

        return promise.then((response) => response.data)

    },
    getProtocolesSoins(id) {
        const promise = Api().get('/consultations/' + id + '/protocoles-de-soins')
        return promise.then((response) => response.data)
    },
 
    getCpnFacteursPonderations(id){
        const promise = Api().get('/consultations/' + id + '/get-facteurs-ponderations')
        return promise.then((response) => response.data)
    },
    updateFacteursPonderations(id,data){
        const promise = Api().put('/consultations/' + id + '/update-facteurs-ponderations',data)
        return promise.then((response) => response.data)

    },

    /**
     * Supprimer une Conduite à tenir
     * @param {*} data 
     */
    deleteCAT(protocole_id) {
        const promise = Api().put('/protocoles/delete/'+protocole_id)
        return promise.then((response) => response.data)
    },

    getStatistiqueSante(data) {
        const promise = Api().get('/diagnostiques/statistique_sante/type_filtre/'+data.type_filtre+'/date/'+data.date+'/liste')
        return promise.then((response) => response.data)
    },

    getConstanteSoinsH0(consultation_id) {
        const promise = Api().get('/consultations/'+consultation_id+'/constantes')
        return promise.then((response) => response.data)
    },

    getOrganeSoinsH0(consultation_id) {
        const promise = Api().get('/consultations/'+consultation_id+'/organes-examines')
        return promise.then((response) => response.data)
    },

    getTypeAppareils() {
        const promise = Api().get('/type-appareils')
        return promise.then((response) => response.data)
    },

    getTypeAppareilExamines(data) {
        const promise = Api().get('/type-appareils/consultation/'+data.consultation_id+'/protocole/'+data.protocole_id+'/liste')
        return promise.then((response) => response.data)
    },

    getListeConsultationExamenClinique(data) {
        const promise = Api().post('/type-appareils/consultation/liste-examen', data)
        return promise.then((response) => response.data)
    },

    storeAppareil(data) {
        const promise = Api().post('/type-appareils', data)
        return promise.then((response) => response.data)
    },

    storeAppareilAExaminer(data) {
        const promise = Api().post('/type-appareils/appareil-a-examiner', data)
        return promise.then((response) => response.data)
    },

    deleteAppareilFromExamenClinique(data) {
        const promise = Api().post('/type-appareils/consultation/appareil/delete', data)
        return promise.then((response) => response.data)
    },

    deleteGroupAppareilFromExamenClinique(data) {
        const promise = Api().post('/type-appareils/consultation/group-appareil/delete', data)
        return promise.then((response) => response.data)
    },

    saveObservationAppareil(data) {
        const promise = Api().post('/type-appareils/appareil-a-examiner/observation', data)
        return promise.then((response) => response.data)
    },

    deleteAppareilObservation(data) {
        const promise = Api().post('/type-appareils/appareil-a-examiner/observation/delete', data)
        return promise.then((response) => response.data)
    },

    getEtatProtocoleEnH0(consultation_id) {
        const promise = Api().get('/consultations/'+consultation_id+'/etat-protocole-h0')
        return promise.then((response) => response.data)
    },

    getConsultationInfoComplementaire(data) {
        const promise = Api().post('/consultations/liste/info-complementaires', data)
        return promise.then((response) => response.data)
    },

    saveConsultationInfoComplementaire(data) {
        const promise = Api().post('/consultations/info-complementaires', data)
        return promise.then((response) => response.data)
    },

    deleteConsultationInfoComplementaire(data) {
        const promise = Api().post('/consultations/info-complementaires/delete', data)
        return promise.then((response) => response.data)
    },

    getConsultationConstante(data) {
        const promise = Api().post('/consultations/list/constantes', data)
        return promise.then((response) => response.data)
    },

    getConsultationConstanteComplementaire(data) {
        const promise = Api().post('/consultations/list/constantes/complementaire', data)
        return promise.then((response) => response.data)
    },

    saveConsultationConstante(data) {
        const promise = Api().post('/consultations/store/constantes', data)
        return promise.then((response) => response.data)
    },

    deleteConsultationConstante(data) {
        const promise = Api().post('/consultations/delete/constantes', data)
        return promise.then((response) => response.data)
    },

    saveDureeBonConsultations(data) {
        const promise = Api().post('/consultations/update-duree-bon', data)
        return promise.then((response) => response.data)
    },

    saveNextRDV(data) {
        const promise = Api().post('/rdv/prochain-rdv', data)
        return promise.then((response) => response.data)
    },
}